function onChangeToValue(event?: any) {
  return event.target.value;
}

export default onChangeToValue;
